export const AhuType = {
  COMPACT: 1,
  ENERGY_PRIME_STANDARD: 2,
  ENERGY_PRIME_GENIUS: 3,
  AQUA_PRIME_STANDARD: 4,
  AQUA_PRIME_GENIUS: 5,
  LINE_PRIME: 6,
  COMPACT_VERTICAL: 7,
};
